import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  PreloadAllModules,
  provideRouter,
  Router,
  withInMemoryScrolling,
  withPreloading,
  // withViewTransitions,
} from "@angular/router";
import * as Sentry from "@sentry/angular";

import {
  BrowserModule,
  provideClientHydration,
  withEventReplay,
} from "@angular/platform-browser";
import { environment } from "src/environments/environment";

import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { ServiceWorkerModule } from "@angular/service-worker";
import { FormsModule } from "@angular/forms";

import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from "ngx-google-analytics";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),

    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    ...(environment.production
      ? [
          {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
              showDialog: false,
            }),
          },
          {
            provide: Sentry.TraceService,
            deps: [Router],
          },
        ]
      : []),

    importProvidersFrom([
      BrowserModule,
      ServiceWorkerModule.register("ngsw-worker.js", {
        enabled: environment.production,
      }),
      CommonModule,
      NgxGoogleAnalyticsModule.forRoot("G-V2XM4E3XXK"),
      NgxGoogleAnalyticsRouterModule,
    ]),
  ],
};
